import {Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

import { MatRadioChange } from '@angular/material/radio';

import {BaseComponent, RadioGroupControl} from '../../classes';

import {RadioGroupOptionInterface} from './interfaces/radio-group-option.interface';
import {ComponentTypesEnum} from '../../enums';

@Component({
    selector: 'app-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrls: ['./radio-group.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RadioGroupComponent),
        multi: true
    }]
})
export class RadioGroupComponent extends BaseComponent<string | number, MatRadioChange, RadioGroupControl>
    implements OnInit, ControlValueAccessor {

    @Input() public panelClass: string;

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);
    }

    private checkOption(option: RadioGroupOptionInterface) {
        this.asFormsControl().options.map((radioOption: RadioGroupOptionInterface) => {

            if (radioOption !== option) {
                radioOption.checked = false;

                return;
            }

            radioOption.checked = true;

            super.writeValue(radioOption.value);
        });
    }

    ngOnInit(): void {
        this.asFormsControl();
        this.checkInvalid();
    }

    changeValue(event: MatRadioChange): void {
        /**
         * The following actions are executed:
         */

        /**
         * The UI control value is synchronized
         * with model or reactive form control value.
         */
        this.onChange(event.value);

        /**
         * Synchronize parent value
         */
        super.writeValue(event.value);

        /**
         * Mark the UI control as visited(changed from user)
         */
        this.onTouched();

        this.checkInvalid();
        this.control.resetErrors();
    }

    /**
     * Override parent writeValue method.
     */
    writeValue(value: string | number): void {
        if (Array.isArray(this.asFormsControl().options) && this.asFormsControl().options.length > 0) {
            const filteredOptions = this.asFormsControl().options.filter((option: RadioGroupOptionInterface) => {
                return option.value === value;
            });

            if (filteredOptions.length !== 0) {
                this.checkOption(filteredOptions[0]);
            }
        }

        this.checkInvalid();
        this.control.resetErrors();
    }

    asFormsControl(): RadioGroupControl {
        if (!this.control || !(this.control instanceof RadioGroupControl)) {
            this.control = new RadioGroupControl({
                name: '',
                value: '',
                placeholder: '',
                validators: [],
                componentType: ComponentTypesEnum.RadioGroup,
                invalid: false,
                errors: [],
                options: []
            });
        }

        return (this.control as RadioGroupControl);
    }
}
